module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page-contact",
    attrs: {
      "id": "page-contact"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__select-question"
  }, [_vm._v("\n                            Wil je jouw persoonlijke profiel en aanvullende informatie op maat ontvangen?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "push-buttons"
  }, [_c('div', {
    staticClass: "push-button",
    class: {
      'push-button--selected': _vm.opMaat
    },
    on: {
      "click": function($event) {
        _vm.booleanButtonHandler('opMaat', true, $event)
      }
    }
  }, [_vm._v("Ja\n                            ")]), _c('div', {
    staticClass: "push-button",
    class: {
      'push-button--selected': !_vm.opMaat
    },
    on: {
      "click": function($event) {
        _vm.booleanButtonHandler('opMaat', false, $event)
      }
    }
  }, [_vm._v("Nee\n                            ")])])])]), _vm._v(" "), (_vm.opMaat) ? _c('div', [_c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__form-title"
  }, [_vm._v("Naam")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.naam),
      expression: "naam"
    }],
    staticClass: "typeahead__input",
    attrs: {
      "id": "input-naam",
      "tabindex": "1",
      "type": "text"
    },
    domProps: {
      "value": (_vm.naam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.naam = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__form-title"
  }, [_vm._v("E-mailadres")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "input-email",
    staticClass: "typeahead__input",
    attrs: {
      "id": "input-email",
      "tabindex": "2",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (_vm.opMaat) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__select-question"
  }, [_vm._v("\n                            Wil je in de toekomst op de hoogte worden gebracht als er in jouw regio projecten starten op het gebied van hybride docentschap?                            ")]), _vm._v(" "), _c('div', {
    staticClass: "push-buttons"
  }, [_c('div', {
    staticClass: "push-button",
    class: {
      'push-button--selected': _vm.opDeHoogteBrengenProjecten
    },
    on: {
      "click": function($event) {
        _vm.booleanButtonHandler('opDeHoogteBrengenProjecten', true, $event)
      }
    }
  }, [_vm._v("Ja\n                            ")]), _c('div', {
    staticClass: "push-button",
    class: {
      'push-button--selected': !_vm.opDeHoogteBrengenProjecten
    },
    on: {
      "click": function($event) {
        _vm.booleanButtonHandler('opDeHoogteBrengenProjecten', false, $event)
      }
    }
  }, [_vm._v("Nee\n                            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.opMaat && _vm.opDeHoogteBrengenProjecten) ? _c('div', [_c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__form-title"
  }, [_vm._v("Woonplaats")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.woonplaats),
      expression: "woonplaats"
    }],
    ref: "input-woonplaats",
    staticClass: "typeahead__input",
    attrs: {
      "id": "input-woonplaats",
      "tabindex": "3",
      "type": "text"
    },
    domProps: {
      "value": (_vm.woonplaats)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.woonplaats = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__form-title"
  }, [_vm._v("Opleiding")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opleiding),
      expression: "opleiding"
    }],
    ref: "input-opleiding",
    staticClass: "typeahead__input",
    attrs: {
      "id": "input-opleiding",
      "tabindex": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.opleiding)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.opleiding = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__form-title"
  }, [_vm._v("Huidige functie")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.huidigeFunctie),
      expression: "huidigeFunctie"
    }],
    ref: "input-functie",
    staticClass: "typeahead__input",
    attrs: {
      "id": "input-functie",
      "tabindex": "5",
      "type": "text"
    },
    domProps: {
      "value": (_vm.huidigeFunctie)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.huidigeFunctie = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.opMaat) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('div', {
    staticClass: "page-contact__select-question"
  }, [_vm._v("\n                            Wil je in de toekomst op de hoogte worden gehouden via onze nieuwsbrief?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "push-buttons"
  }, [_c('div', {
    staticClass: "push-button",
    class: {
      'push-button--selected': _vm.nieuwsbrief
    },
    on: {
      "click": function($event) {
        _vm.booleanButtonHandler('nieuwsbrief', true, $event)
      }
    }
  }, [_vm._v("Ja\n                            ")]), _c('div', {
    staticClass: "push-button",
    class: {
      'push-button--selected': !_vm.nieuwsbrief
    },
    on: {
      "click": function($event) {
        _vm.booleanButtonHandler('nieuwsbrief', false, $event)
      }
    }
  }, [_vm._v("Nee")])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors && _vm.submitAttempt) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.opMaat) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "tabindex": "6"
    },
    on: {
      "click": function($event) {
        _vm.aanvragenHandler($event)
      }
    }
  }, [_vm._v("Verstuur")]), _vm._v(" "), (_vm.submitPending) ? _c('div', {
    staticClass: "fa-3x",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-4-sm col-8"
  }, [_c('div', {
    staticClass: "page__icon-wrapper"
  }, [_c('i', {
    staticClass: "far fa-address-card",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('h1', [_vm._v("Leuk dat je interesse hebt in het hybride docentschap!")]), _vm._v(" "), _c('p', {
    staticClass: "page-contact__intro"
  }, [_vm._v("Graag sturen we je jouw persoonlijke profiel toe, inclusief informatie op "), _c('u', [_vm._v("maat")]), _vm._v(" over vervolgstappen die je kunt nemen om het hybride docentschap in de praktijk te gaan brengen.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('p', [_vm._v("Bedankt! Meer informatie is te vinden op "), _c('a', {
    attrs: {
      "href": "http://www.hybridedocent.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.hybridedocent.nl")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a2c96a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-contact.vue
// module id = 150
// module chunks = 0